import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, toHandlers as _toHandlers, withKeys as _withKeys, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-4 ext-attr-group" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "variant-values"
}
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mb-3"
}
const _hoisted_9 = ["onClick", "disabled"]
const _hoisted_10 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  class: "me-2 flex-shrink-0",
  style: {"width":"2rem"}
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "flex-grow-1 min-w-0" }
const _hoisted_15 = { class: "fw-medium text-truncate" }
const _hoisted_16 = ["aria-expanded", "onClick", "onKeydown"]
const _hoisted_17 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_18 = {
  class: "me-2 flex-shrink-0",
  style: {"width":"1.5rem"}
}
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "flex-grow-1 min-w-0" }
const _hoisted_21 = { class: "text-truncate d-block" }
const _hoisted_22 = { class: "fw-medium" }
const _hoisted_23 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_25 = { class: "row g-2" }
const _hoisted_26 = ["onClick", "title", "onKeydown"]
const _hoisted_27 = {
  class: "variant-image-container d-flex align-items-center justify-content-center position-relative",
  style: {"width":"100%","aspect-ratio":"1","min-height":"60px"}
}
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 1,
  class: "variant-image-placeholder text-muted d-flex align-items-center justify-content-center h-100"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "pis-icon pis-icon-image pis-icon-lg" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component mt-4", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady && _ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.t('Variants')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variants, (variant, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: variant.attributeCode || index,
                class: "mb-4"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: "fw-bold",
                      innerHTML: variant.attributeName
                    }, null, 8, _hoisted_6)
                  ])
                ]),
                (_ctx.getVariantValues(variant).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (variant.displayMode === _ctx.VariantAttributeDisplayModeEnum.Pills)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVariantValues(variant), (value) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: value.attributeValueText,
                                type: "button",
                                class: _normalizeClass(["btn btn-sm", {
                  active: value.selected,
                  'btn-outline-primary':
                    _ctx.componentOptions.unavailableValuesBehavior !==
                      _ctx.UnavailableValuesBehavior.Disabled || value.match,
                  'btn-outline-secondary':
                    _ctx.componentOptions.unavailableValuesBehavior ===
                      _ctx.UnavailableValuesBehavior.Disabled && !value.match,
                }]),
                                onClick: ($event: any) => (value.product && _ctx.details(value)),
                                disabled: 
                  _ctx.componentOptions.unavailableValuesBehavior ===
                    _ctx.UnavailableValuesBehavior.Disabled && !value.match
                
                              }, [
                                _createElementVNode("span", null, _toDisplayString(value.attributeValueText), 1)
                              ], 10, _hoisted_9))
                            }), 128))
                          ]))
                        : (variant.displayMode === _ctx.VariantAttributeDisplayModeEnum.Dropdown)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_Dropdown, {
                                open: _ctx.isDropdownOpen[variant.attributeCode || ''],
                                "onUpdate:open": ($event: any) => ((_ctx.isDropdownOpen[variant.attributeCode || '']) = $event),
                                width: "100%",
                                items: 
                  _ctx.getVariantValues(variant).map((value) => ({
                    type: 'value',
                    value,
                  }))
                
                              }, {
                                item: _withCtx(({ item }) => [
                                  (item.type === 'value')
                                    ? (_openBlock(), _createBlock(_component_Clickable, {
                                        key: 0,
                                        class: _normalizeClass(["dropdown-item py-2", {
                      active: item.value.selected,
                      disabled:
                        _ctx.componentOptions.unavailableValuesBehavior ===
                          _ctx.UnavailableValuesBehavior.Disabled && !item.value.match,
                    }]),
                                        onClick: ($event: any) => {
                      _ctx.toggleDropdown(variant.attributeCode || '');
                      _ctx.details(item.value);
                    }
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                              (item.value.product?.images?.length)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: item.value.product.images[0].thumbnailUrl,
                                                    alt: item.value.name,
                                                    class: "img-fluid rounded border",
                                                    style: {"max-height":"1.5rem","object-fit":"contain"},
                                                    loading: "lazy"
                                                  }, null, 8, _hoisted_13))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                              _createElementVNode("div", _hoisted_15, _toDisplayString(item.value.attributeValueText), 1)
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                activator: _withCtx(({ on }) => [
                                  _createElementVNode("div", _mergeProps(_toHandlers(on, true), {
                                    class: "form-select d-flex align-items-center",
                                    tabindex: "0",
                                    role: "combobox",
                                    "aria-expanded": _ctx.isDropdownOpen[variant.attributeCode || ''] ? 'true' : 'false',
                                    "aria-haspopup": "listbox",
                                    onClick: ($event: any) => (_ctx.toggleDropdown(variant.attributeCode || '')),
                                    onKeydown: [
                                      _withKeys(($event: any) => (_ctx.toggleDropdown(variant.attributeCode || '')), ["enter"]),
                                      _withKeys(_withModifiers(($event: any) => (_ctx.toggleDropdown(variant.attributeCode || '')), ["prevent"]), ["space"])
                                    ],
                                    style: {"cursor":"pointer","background-color":"white"}
                                  }), [
                                    _createElementVNode("div", _hoisted_17, [
                                      (_ctx.getSelectedValue(variant))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_18, [
                                              (_ctx.getSelectedValue(variant)!.product?.images?.length)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _ctx.getSelectedValue(variant)?.product?.images?.[0]?.thumbnailUrl,
                                                    alt: _ctx.getSelectedValue(variant)!.attributeValueText,
                                                    class: "img-fluid rounded border",
                                                    style: {"max-height":"1.5rem","object-fit":"contain"}
                                                  }, null, 8, _hoisted_19))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                              _createElementVNode("span", _hoisted_21, [
                                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.getSelectedValue(variant)!.attributeValueText), 1)
                                              ])
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.t('SelectVariant')), 1))
                                    ])
                                  ], 16, _hoisted_16)
                                ]),
                                _: 2
                              }, 1032, ["open", "onUpdate:open", "items"])
                            ]))
                          : (variant.displayMode === _ctx.VariantAttributeDisplayModeEnum.Images)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVariantValues(variant), (value) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: value.attributeValueText,
                                      class: "col-xl-2 col-lg-3 col-md-4 col-sm-4 col-4"
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["card h-100 text-center position-relative", {
                      'border-primary': value.selected,
                      'opacity-50':
                        _ctx.componentOptions.unavailableValuesBehavior ===
                          _ctx.UnavailableValuesBehavior.Disabled && !value.match,
                      'border-1': value.selected,
                    }]),
                                        onClick: ($event: any) => (value.product && _ctx.details(value)),
                                        title: value.attributeValueText,
                                        role: "button",
                                        tabindex: "0",
                                        style: _normalizeStyle({
                      cursor:
                        _ctx.componentOptions.unavailableValuesBehavior ===
                          _ctx.UnavailableValuesBehavior.Disabled && !value.match
                          ? 'not-allowed'
                          : 'pointer',
                      transition: 'all 0.15s ease-in-out',
                    }),
                                        onKeydown: [
                                          _withKeys(($event: any) => (value.product && _ctx.details(value)), ["enter"]),
                                          _withKeys(_withModifiers(($event: any) => (value.product && _ctx.details(value)), ["prevent"]), ["space"])
                                        ]
                                      }, [
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("div", null, [
                                            (value.product?.images?.length)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: value.product.images[0].thumbnailUrl,
                                                  alt: value.attributeValueText,
                                                  class: "variant-image img-fluid",
                                                  style: {"max-height":"100%","max-width":"100%","object-fit":"contain"}
                                                }, null, 8, _hoisted_28))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                                          ])
                                        ])
                                      ], 46, _hoisted_26)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}